export const OWNER = "Owner";
export const ADVISOR = "Advisor";
export const KEYHOLDER = "Keyholder";
export const GUARDIAN = "Guardian";

export const purposeMapping = {
  'EMERGENCY': 'Medical Emergency',
  'MISSING': "'If I Go Missing' Folder" ,
  'STORAGE': 'Document Storage',
  'ESTATE_PLANNING': 'Estate Planning',
  'REAL_ESTATE': 'Real Estate Documents',
  'OTHER': 'Other',
};

export const statusMapping = {
  'OPEN': 'Pending Approval',
  'APPROVED': "'Approved" ,
  'REJECTED': 'Rejected',
  'CLOSED': 'Closed',
};

export const accessDelayMapping = {
  "NONE": "no delay",
  "ONE_DAY": "one day",
  "TWO_DAYS": "two days",
  "THREE_DAYS": "three days",
  "WEEK": "one week",
  "MONTH": "one month",
};

export const subscriptionTypeMapping = {
  "FREE_TRIAL": "Free Trial",
  "MONTHLY": "Monthly",
  "ANNUAL": "Annual",
  "LIFETIME": "Lifetime Access",
};

export const VAULT_STATUS_ICON_MAPPING = {
  PENDING: 'key',
  LOCKED: 'lock',
  UNLOCKED: 'lock-open',
  ARCHIVED: 'box',
};

export const VAULT_ICON_COLOR_MAPPING = {
  PENDING: 'text-warning',
  LOCKED: 'text-primary',
  UNLOCKED: '',
  ARCHIVED: 'text-grey',
};

export const VAULT_STATUS_DESCRIPTION_MAPPING = {
  PENDING: 'This vault has a request for access that is pending approval from guardians.',
  LOCKED: 'This vault is locked. Only the owner can access the documents in the vault.',
  UNLOCKED: 'This vault has been unlocked. The Keyholders can access the documents in the vault.',
  ARCHIVED: 'This vault has been archived and is no longer active. Documents are no longer stored, and access can not be requested.',
};

export const VAULT_STATUS_TEXT_MAPPING = {
  PENDING: 'Pending Access Request.',
  LOCKED: 'Vault is Secure.',
  UNLOCKED: 'Vault is Unlocked.',
  ARCHIVED: 'Vault has been Archived.',
};

export const USER_ICON_MAPPING = {
  'Owner': 'user-lock',
  'Keyholder': 'user-friends',
  'Guardian': 'user-shield',
  'Advisor': 'user-tie'
}

export const DOCUMENT_CATEGORIES = {
  TAX: {
    title: 'Tax Documents',
    description: 'Includes tax returns, 1099 forms, etc'
  },
  INCOME: {
    title: 'Income Verification',
    description: 'Includes tax returns, 1099 forms, etc'
  },
  ESTATE: {
    title: 'Estate Planning Documents',
    description: 'Includes tax returns, 1099 forms, etc'
  }
}